module.exports = __webpack_public_path__ + "images/logos/logo-supergoop-small-b7a492501d576e490c37772f85ca014b.webp";